import { type ReactNode } from 'react';

import styles from './GalleryLayout.css';

export function GalleryLayout({
  slider,
  sliderAddons,
  thumbnails,
}: {
  slider: JSX.Element;
  sliderAddons?: JSX.Element;
  thumbnails?: JSX.Element;
}): ReactNode {
  return (
    <div className={styles['wrapper']} data-testid="card-gallery.container">
      <div className={styles['slider']}>
        <div className={styles['slider-inner']}>{slider}</div>
        {sliderAddons}
      </div>
      {thumbnails && <div className={styles['thumbnails']}>{thumbnails}</div>}
    </div>
  );
}
